import styled from 'styled-components';
export const InputText = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    padding: 1rem 0;
    position: relative;
    border-bottom: 1px solid #eff3f8;
    &.active {
      border-bottom: 2px solid #2276e3;
    }
    label {
      font-size: 1.6rem;
      color: #898b91;
    }
    input[type=text] {
        border: 0;
        outline: 0;
        padding: 1rem 0 0;
        font-size: 1.8rem;
        font-weight: 500;
        &::focus {
          border-bottom: 2px solid #2276e3;
        }
        font-family: ${props.theme.font.fontFamily};
        &::placeholder { 
            overflow: visible; 
            font-weight: 500;
            color: #898b91;
        }
    }
`,
);

export const AutoSuggest = styled.section`
  top: ${p => p.top || ''};
  background: white;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  border-radius: 1.2rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 53rem;
  z-index: 7;
  max-height: 48rem;
  overflow-y: scroll;
  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    
  }
`;
